type Callback = () => void;

export const customSetTimeout = (callBack: Callback, ms?: number): number =>
    setTimeout(callBack, ms) as unknown as number;
